import { push, replace } from "connected-react-router";
import { api } from "core";
import { getCookie } from "core/utils";
import {
  clearSessionUuid,
  endSession,
  setSessionUuid,
  startHeartbeat,
} from "core/tracking";

export const tryToLoadTokens = () => (dispatch) => {

  const params = new URLSearchParams(window.location.search);
  const ssoAccessToken = params.get('access_token');
  const ssoRefreshToken = params.get('refresh_token');

  if (ssoAccessToken && ssoRefreshToken) {
    window.history.replaceState({}, document.title, window.location.pathname);

    dispatch(tokenAcquired(ssoAccessToken, ssoRefreshToken));

    const ssoSessionUuid = params.get("session_uuid");
    if (ssoSessionUuid) {
      setSessionUuid(ssoSessionUuid);
    }

    api.getSchoolList().then((response) => {
      const userSchool = response.data && response.data[0] && response.data[0].id;
      if (userSchool) {
        dispatch(selectSchool(userSchool));
      }
    });
    return;
  }

  const old_access_token = getCookie("old_access_token");
  const old_codigo_usuario = getCookie("old_codigo_usuario");
  const localstorage_old_access_token =
    localStorage.getItem("old_access_token");
  const localstorage_old_codigo_usuario =
    localStorage.getItem("old_codigo_usuario");
  if (
    old_access_token &&
    old_codigo_usuario &&
    (old_access_token !== localstorage_old_access_token ||
      old_codigo_usuario !== localstorage_old_codigo_usuario)
  ) {
    dispatch(tryLegacyLogin(old_access_token, old_codigo_usuario));
  } else {
    const tokens = {
      access_token: localStorage.getItem("access_token"),
      refresh_token: localStorage.getItem("refresh_token"),
    };
    if (tokens.access_token !== null && tokens.refresh_token !== null) {
      dispatch(tokenAcquired(tokens.access_token, tokens.refresh_token));
      startHeartbeat();
      const userSchool = localStorage.getItem("user.school");
      if (userSchool && userSchool !== "undefined" && userSchool !== "null") {
        dispatch(selectSchool(userSchool));
      } else {
        localStorage.removeItem("user.school");
        dispatch(logout());
      }
    }
  }
};

const tryLegacyLogin =
  (old_access_token, old_codigo_usuario) => (dispatch, getState) =>
    api.instance
      .post("/authRedirect", { old_access_token })
      .then((loginResponse) => {
        dispatch(
          tokenAcquired(
            loginResponse.data.access_token,
            loginResponse.data.refresh_token,
          ),
        );
        setSessionUuid(loginResponse.data.session_uuid);
        return api.getSchoolList().then((response) => {
          // TODO: when this user has no school?
          const userSchool =
            response.data && response.data[0] && response.data[0].id;
          if (userSchool) {
            dispatch(selectSchool(userSchool));
            dispatch(replace(getState().view.login.backTo));
          } else {
            dispatch(tryToLoadTokens());
          }
        });
      })
      .catch((err) => {
        dispatch(tryToLoadTokens());
      })
      .finally((payload) => {
        localStorage.setItem("old_access_token", old_access_token);
        localStorage.setItem("old_codigo_usuario", old_codigo_usuario);
      });

export const tokenAcquired = (token, refresh_token) => (dispatch, getState) => {
  // set cookie to get cookie-authenticated endpoints such as images
  const today = new Date();
  const expires = new Date();
  expires.setTime(today.getTime() + 1e3 * 60 * 60 * 24 * 30);
  /** @todo auth cookie-authenticated at localhost/other local domains */
  document.cookie = `bearer_token=${token}; Domain=.clickideia.com.br; expires=${expires.toGMTString()}; path=/; SameSite=None; Secure`;

  api.instance.defaults.headers.common["Authorization"] = "Bearer " + token;
  localStorage.setItem("access_token", token);
  localStorage.setItem("refresh_token", refresh_token);
  window.clearInterval(getState().user.refreshIntervalId);
  /** @todo deal with refresh long interval in backend (1 month). Maybe, some sw may do te job */
  const intervalId = window.setInterval(
    () => dispatch(refreshToken()),
    60 * 60 * 24 * 30,
  ); // 1 month
  return dispatch({
    type: "user.tokenAcquired",
    payload: { access_token: token, refresh_token: refresh_token, intervalId },
  });
};

export const refreshToken = () => (dispatch, getState) => {
  api
    .refresh_token(getState().user.refresh_token)
    .then((response) =>
      dispatch(
        tokenAcquired(response.data.access_token, response.data.refresh_token),
      ),
    )
    .catch(() => {});
};

export const selectSchool = (schoolId) => (dispatch) => {
  if (!schoolId || schoolId === "undefined" || schoolId === "null") return;
  dispatch({
    type: "user.schoolSelected",
    payload: { school: schoolId },
  });
  dispatch(getUserInfo(schoolId));
  dispatch(loadDefaultSubjects());
  dispatch(getSchoolTeachers(schoolId));
};

const getSchoolTeachers = (schoolId) => (dispatch) => {
  return api.getSchoolTeachers(schoolId).then(({ data }) =>
    dispatch({
      type: "user.schoolTeachers.success",
      payload: data,
    }),
  ).catch(() => {});
};

const transformUserInfo = (userInfo) => ({
  ...userInfo,
  user: {
    ...userInfo.user,
    type: {
      1: "student",
      2: "teacher",
      3: "employee",
      4: "manager",
      5: "admin",
    }[userInfo.user.type],
  },
});
export const getUserInfo = (userSchool) => (dispatch) => {
  dispatch({ type: "user.isLoading" });
  api.getUserInfo(userSchool).then((response) =>
    dispatch({
      type: "user.infoLoaded",
      payload: transformUserInfo(response.data),
    }),
  ).catch(() => {});
};

export const loadDefaultSubjects = () => (dispatch) => {
  api.getDefaultSubjects().then((subjects) =>
    dispatch({
      type: "user.defaultSubjectsLoaded",
      payload: subjects,
    }),
  ).catch(() => {});
};
const clearSession = (dispatch, getState, keepUserRecord) => {
  clearSessionUuid();
  delete api.instance.defaults.headers.common["Authorization"];
  localStorage.removeItem("user.school");
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  window.clearInterval(getState().user.refreshIntervalId);
  // Clear bearer_token cookie
  document.cookie =
    "bearer_token=; Domain=.clickideia.com.br; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
  // Notify HQ iframe about logout
  const hqUrl = process.env.REACT_APP_HQ_URL;
  if (hqUrl) {
    const iframes = document.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
      try {
        iframe.contentWindow.postMessage({ type: "PORTAL_LOGOUT" }, hqUrl);
      } catch (e) {
        // ignore cross-origin errors
      }
    });
  }
  if (!keepUserRecord) {
    localStorage.removeItem("old_access_token");
    localStorage.removeItem("old_codigo_usuario");
    dispatch({ type: "user.logout" });
  }
  if (getState().router.location.pathname !== "/Login") {
    dispatch(push("/Login"));
  }
};

export const logout = (keepUserRecord) => (dispatch, getState) => {
  return endSession()
    .catch(() => {})
    .then(() => api.logout())
    .then(() => clearSession(dispatch, getState, keepUserRecord))
    .catch(() => clearSession(dispatch, getState, keepUserRecord));
};
